import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";
import { Textbox } from "..";

export interface DynamicDbDisplayValueSearchListener extends EventListener<DynamicDbDisplayValueSearchEvent> {
}

export class DynamicDbDisplayValueSearchEvent extends Event<Textbox> {
    private _addlValues: any = {};

    constructor(target: Textbox, domEvent?: DomEvent) {
        super(target, domEvent);
    }

    public get addlValues(): any {
        return this._addlValues;
    }

    public set addlValues(value: any) {
        this._addlValues = value;
    }

    public addAddlValue(key: string, value: any) {
        this.addlValues[key] = value;
    }
}
